<script lang="ts">
export default {
  name: 'KkItemListModal',
}
</script>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { KkModal, KkButton } from '../../base'

export interface Props {
  isVisible: boolean
  headerLabel: string
  itemList: { name: string }[]
}

export interface Emits {
  (key: 'close'): void
}

const props = defineProps<Props>()
const emits = defineEmits<Emits>()
const { t } = useI18n()
</script>

<template>
  <KkModal width="720px" :is-visible="props.isVisible" @change="emits('close')">
    <div class="content__header">
      {{ props.headerLabel }}
    </div>
    <div class="content__body">
      <div v-for="(item, index) in props.itemList" :key="`item__${index}`" class="content__item">
        {{ item.name }}
      </div>
    </div>
    <div class="content__footer">
      <div class="buttonGroup">
        <div class="buttonGroup__item">
          <KkButton
            color="secondary"
            outlined
            :text="t('labels.close')"
            @click="emits('close')"
          />
        </div>
      </div>
    </div>
  </KkModal>
</template>

<style lang="scss" scoped>
.item {
  padding: 0 12px 12px;
}
.content {
  &__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 24px 32px 16px;
    font-weight: 700;
    font-size: 20px;
    line-height: 1.5;
    border-bottom: 1px solid #E4E7EB;
  }
  &__body {
    height: 50vh;
    padding: 24px;
    overflow-y: scroll;
  }
  &__item {
    padding: 0 12px 12px;
  }
  &__footer {
    padding: 32px;
    border-top: 1px solid #E4E7EB;
  }
}
.buttonGroup {
  display: flex;
  flex-grow: 0;
  justify-content: flex-end;
}
</style>
